const youzheng = [{
  path: '/',
  name: 'index',
  meta: {
    title: '邮政工会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/index'], resolve)
  }
},
{
  path: '/service/bmfw',
  name: 'ser-bmfw',
  meta: {
    title: '便民服务',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/bianminfuwu/index'], resolve)
  }
},
{
  path: '/news',
  name: 'news',
  meta: {
    title: '邮政工会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Newscenter'], resolve)
  }
},
{
  path: '/yzDetail/:type',
  name: 'yzDetail',
  meta: {
    title: '邮政工会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/detail'], resolve)
  }
},
{
  path: '/yzQuestion/:type',
  name: 'yzQuestion',
  meta: {
    title: '问卷调查',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/wenjuan/index'], resolve)
  }
},
{
  path: '/yzQuestionAsk/:type/:activityid',
  name: 'yzQuestionAsk',
  meta: {
    title: '问卷调查',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/wenjuan/ask'], resolve)
  }
},
{
  path: '/userinfo',
  name: 'userinfo',
  meta: {
    title: '个人中心',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/userinfo'], resolve)
  }
},
{
  path: '/userinfo/edit',
  name: 'userinfoEdit',
  meta: {
    title: '个人资料修改',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/userinfoEdit'], resolve)
  }
},
{
  path: '/userinfo/order',
  name: 'order',
  meta: {
    title: '我的订单',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/order'], resolve)
  }
},
{
  path: '/weiyitong',
  name: 'weiyitong',
  meta: {
    title: '微医通',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/weiyitong'], resolve)
  }
},
{
  path: '/mall/orderlist',
  name: 'mallOrderlist',
  meta: {
    title: '积分商城',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/orderlist'], resolve)
  }
},
{
  path: '/carnival/list',
  name: 'carnivalList',
  meta: {
    title: '嘉年华',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/carnival/list'], resolve)
  }
},
{
  path: '/userinfo/integral',
  name: 'integral',
  meta: {
    title: '我的积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/integral'], resolve)
  }
},
{
  path: '/userinfo/sign',
  name: 'mysign',
  meta: {
    title: '签到',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/sign'], resolve)
  }
},
{
  path: '/userinfo/signlist',
  name: 'signList',
  meta: {
    title: '积分记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/signList'], resolve)
  }
},
{
  path: '/userinfo/address',
  name: 'address',
  meta: {
    title: '收货地址',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/address'], resolve)
  }
},
{
  path: '/userinfo/addressSelect',
  name: 'addressSelect',
  meta: {
    title: '收货地址',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/address-select'], resolve)
  }
},
{
  path: '/userinfo/address/add/:ID',
  name: 'addressAdd',
  meta: {
    title: '收货地址',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/address-add'], resolve)
  }
},
{
  path: '/tuangou/list',
  name: 'tuanGouList',
  meta: {
    title: '团购活动',
    NeedLogin: false,
    keepAlive: true
  },
  component: resolve => {
    require(['../views/tuangou/list'], resolve)
  }
},
{
  path: '/tuangou/detail/:id',
  name: 'tuanGouDetail',
  meta: {
    title: '活动详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/tuangou/detail'], resolve)
  }
},
{
  path: '/activity/list',
  name: 'activity',
  meta: {
    title: '嘉年华',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/activity/list'], resolve)
  }
},
{
  path: '/mail/common/declare',
  name: 'declare',
  meta: {
    title: '我要申报',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/common/declare'], resolve)
  }
},
{
  path: '/mail/common/myMailCommon',
  name: 'myMailCommon',
  meta: {
    title: '我的',
    NeedLogin: false,
    keepAlive: true
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/common/my-email-common'], resolve)
  }
},
{
  path: '/mail/worker/myReply/:id',
  name: 'myReply',
  meta: {
    title: '我的回复',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/worker/my-reply'], resolve)
  }
},
{
  path: '/mail/worker/myReplyOther/:id',
  name: 'myReplyOther',
  meta: {
    title: '我的回复',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/worker/my-reply-other'], resolve)
  }
},
{
  path: '/mail/common/myMailDetailCommon/:id',
  name: 'myMailDetailCommon',
  meta: {
    title: '我的',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/common/mail-detail-common'], resolve)
  }
},
{
  path: '/mail/worker/myDetailWork/:id/:select',
  name: 'myDetailWork',
  meta: {
    title: '我的',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/worker/mail-detail-work'], resolve)
  }
},
{
  path: '/mail/worker/index',
  name: 'myMailWorkIndex',
  meta: {
    title: '主席信箱首页',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhuxixinxiang/worker/index'], resolve)
  },
  children: [{
    path: ':selected',
    name: 'myMailWorkdeclare',
    component: resolve => {
      require(['../views/zhuxixinxiang/worker/declare'], resolve)
    }
  },
  {
    path: 'myzixun/:selected',
    name: 'myMailWorkZixun',
    component: resolve => {
      require(['../views/zhuxixinxiang/worker/list'], resolve)
    }
  },
  {
    path: 'myDaiban/:selected/:tabIndex',
    name: 'myMailWorkDaiban',
    component: resolve => {
      require(['../views/zhuxixinxiang/worker/my-email-work'], resolve)
    }
  },
  {
    path: 'myDaibanqy/:selected/:tabIndex',
    name: 'myMailWorkQyDaiban',
    component: resolve => {
      require(['../views/zhuxixinxiang/worker/my-email-work-qyb'], resolve)
    }
  }
  ]
},
{
  path: '/lawyer/index',
  name: 'lawyerIndex',
  meta: {
    title: '法律服务',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/index'], resolve)
  }
},
{
  path: '/lawyer/lawyer/:id',
  name: 'lawyerDetail',
  meta: {
    title: '律师详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/lawyer'], resolve)
  }
},
{
  path: '/lawyer/submit/:id',
  name: 'lawyerSubmit',
  meta: {
    title: '我要咨询',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/submit'], resolve)
  }
},
{
  path: '/lawyer/myask',
  name: 'lawyerAsk',
  meta: {
    title: '我的咨询',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/my-ask'], resolve)
  }
},
{
  path: '/lawyer/worker/tomeask',
  name: 'mylawyerAsk',
  meta: {
    title: '我的咨询',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/worker/tome-ask'], resolve)
  }
},
{
  path: '/lawyer/worker/answer/:id',
  name: 'mylawyerAnswer',
  meta: {
    title: '我的咨询',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/lawyer/worker/answer'], resolve)
  }
},
{
  path: '/mall/index',
  name: 'mallIndex',
  meta: {
    title: '积分商城',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/mallIndex'], resolve)
  }
},
{
  path: '/mall/product/list',
  name: 'mallProductList',
  meta: {
    title: '商品列表',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/productList'], resolve)
  }
},
{
  path: '/mall/product/detail/:id',
  name: 'mallProductDetail',
  meta: {
    title: '商品详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/product-detail'], resolve)
  }
},
{
  path: '/mall/sumbitOrder/:id',
  name: 'mallSubmitOrders',
  meta: {
    title: '填写订单',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/SubmitOrders'], resolve)
  }
},
{
  path: '/carnival/detail/:id',
  name: 'carnivalDetail',
  meta: {
    title: '嘉年华',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/carnival/detail'], resolve)
  }
},
{
  path: '/mall/order/detail/:id',
  name: 'mallOrderDetail',
  meta: {
    title: '积分商城',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mall/order-detail'], resolve)
  }
},
{
  path: '/hgfw',
  name: 'hgfw',
  meta: {
    title: '惠工服务',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/hgfw/hgfw'], resolve)
  }
},
{
  path: '/jfhl/index',
  name: 'jfhlIndex',
  meta: {
    title: '积分换好礼',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/jifenhuanli/index'], resolve)
  }
},
{
  path: '/jfhl/rule',
  name: 'jifenRule',
  meta: {
    title: '活动规则',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/jifenhuanli/rule'], resolve)
  }
},
{
  path: '/jfhl/lottery',
  name: 'jifenLottery',
  meta: {
    title: '抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/jifenhuanli/lottery'], resolve)
  }
},
{
  path: '/answer/index/:partyid',
  name: 'answerLottery',
  meta: {
    title: '答题抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery/index'], resolve)
  }
},
{
  path: '/answer/rule/:partyid',
  name: 'answerRule',
  meta: {
    title: '答题抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery/rule'], resolve)
  }
},
{
  path: '/answer/lottery/:partyid',
  name: 'answerChoujiang',
  meta: {
    title: '答题九宫格抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery/lottery'], resolve)
  }
},
{
  path: '/answer/zzwdg/index/:partyid',
  name: 'zzwdgIndex',
  meta: {
    title: '赞赞我的国',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zanzanwodeguo/index'], resolve)
  }
},
{
  path: '/answer/zzwdg/lottery/:partyid/:partyuserid',
  name: 'zzwdgLottery',
  meta: {
    title: '抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zanzanwodeguo/lottery'], resolve)
  }
},
{
  path: '/answer/zzwdg/rule',
  name: 'zzwdgRule',
  meta: {
    title: '活动规则',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zanzanwodeguo/rule'], resolve)
  }
},
{
  path: '/answer/zzwdg/question/:partyid/:partyuserid',
  name: 'zzwdgAnswer',
  meta: {
    title: '答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zanzanwodeguo/answer'], resolve)
  }
},
{
  path: '/answer/article/index/:artid',
  name: 'articleIndex',
  meta: {
    title: '文章评论',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/article-reviews/index'], resolve)
  }
},
{
  path: '/integralDraw/lottery/:partyid',
  name: 'integralDraw',
  meta: {
    title: '积分抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery'], resolve)
  }
},
{
  path: '/integralDraw/lottery2/:partyid',
  name: 'integralDraw2',
  meta: {
    title: '积分抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery2'], resolve)
  }
},
{
  path: '/integralDraw/lottery3/:partyid',
  name: 'integralDraw3',
  meta: {
    title: '小积分换大积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery3'], resolve)
  }
},
{
  path: '/integralDraw/lottery4/:partyid',
  name: 'integralDraw4',
  meta: {
    title: '小积分换大积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery4'], resolve)
  }
},
{
  path: '/integralDraw/lottery5/:partyid',
  name: 'integralDraw5',
  meta: {
    title: '小积分换大积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery5'], resolve)
  }
},
{
  path: '/integralDraw/lottery6/:partyid',
  name: 'integralDraw6',
  meta: {
    title: '小积分换大积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery6'], resolve)
  }
},
{
  path: '/integralDraw/lottery7/:partyid/:type',
  name: 'integralDraw7',
  meta: {
    title: '一起来闯关',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery7'], resolve)
  }
},
{
  path: '/integralDraw/lottery8/:partyid',
  name: 'integralDraw8',
  meta: {
    title: '一起来闯关',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery8'], resolve)
  }
},
{
  path: '/integralDraw/lottery9/:partyid',
  name: 'integralDraw9',
  meta: {
    title: '一起来闯关',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/lottery9'], resolve)
  }
},
{
  path: '/integralDraw/temp/:partyid',
  name: 'integralDrawTemp',
  meta: {
    title: '小积分换大积分',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/Integral-draw/template'], resolve)
  }
},
{
  path: '/lajifenlei/index/:partyid',
  name: 'lajifenleiIndex',
  meta: {
    title: '垃圾分类我先行',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-lajifenlei/index'], resolve)
  }
},
{
  path: '/lajifenlei/rule',
  name: 'lajifenleiRule',
  meta: {
    title: '活动规则',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-lajifenlei/rule'], resolve)
  }
},
{
  path: '/lajifenlei/answer/:partyid/:partyuserid',
  name: 'lajifenleiAnswer',
  meta: {
    title: '答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-lajifenlei/answer'], resolve)
  }
},
{
  path: '/lajifenlei/lottery/:partyid/:partyuserid',
  name: 'lajifenleiLottery',
  meta: {
    title: '抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-lajifenlei/lottery'], resolve)
  }
},
{
  path: '/dzsw',
  name: 'dzsw',
  meta: {
    title: '电子书屋',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/dzsw'], resolve)
  }
}, {
  path: '/manyidiaocha/index/:type/:paperid',
  name: 'manyidiaocha',
  meta: {
    title: '问卷调查',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/manyidadiaocha/index2'], resolve)
  }
}, {
  path: '/manyidiaocha/index2/:type/:paperid',
  name: 'manyidiaocha2',
  meta: {
    title: '问卷调查',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/manyidadiaocha/index3'], resolve)
  }
}, {
  path: '/manyidiaocha/index3/:type/:paperid',
  name: 'manyidiaocha3',
  meta: {
    title: '问卷调查',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/manyidadiaocha/index4'], resolve)
  }
}, {
  path: '/wenjuanchoujiang/lottery/:type/:activityid',
  name: 'wenjuanchoujiang',
  meta: {
    title: '问卷抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/manyidadiaocha/lottery'], resolve)
  }
}, {
  path: '/manyidiaocha/rule/:type',
  name: 'manyidiaochaRule',
  meta: {
    title: '满意大调查活动规则',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/manyidadiaocha/rule'], resolve)
  }
}, {
  path: '/pingjunjia/index/:partyid',
  name: 'pingjunjiaIndex',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia/index'], resolve)
  }
}, {
  path: '/pingjunjia/result/:partyid',
  name: 'pingjunjiaResult',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia/result'], resolve)
  }
}, {
  path: '/pingjunjia2/index/:partyid',
  name: 'pingjunjiaIndex2',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia2/index'], resolve)
  }
}, {
  path: '/pingjunjia2/result/:partyid',
  name: 'pingjunjiaResult2',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia2/result'], resolve)
  }
}, {
  path: '/pingjunjia3/index/:partyid',
  name: 'pingjunjiaIndex3',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia3/index'], resolve)
  }
}, {
  path: '/pingjunjia3/result/:partyid',
  name: 'pingjunjiaResult3',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia3/result'], resolve)
  }
}, {
  path: '/pingjunjia4/index/:partyid',
  name: 'pingjunjiaIndex4',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia4/index'], resolve)
  }
}, {
  path: '/pingjunjia4/result/:partyid',
  name: 'pingjunjiaResult4',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia4/result'], resolve)
  }
}, {
  path: '/pingjunjia5/index/:partyid',
  name: 'pingjunjiaIndex5',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia5/index'], resolve)
  }
}, {
  path: '/pingjunjia5/result/:partyid',
  name: 'pingjunjiaResult5',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia5/result'], resolve)
  }
}, {
  path: '/pingjunjia6/index/:partyid',
  name: 'pingjunjiaIndex6',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia6/index'], resolve)
  }
}, {
  path: '/pingjunjia6/result/:partyid',
  name: 'pingjunjiaResult6',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia6/result'], resolve)
  }
}, {
  path: '/pingjunjia7/index/:partyid',
  name: 'pingjunjiaIndex7',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia7/index'], resolve)
  }
}, {
  path: '/pingjunjia7/result/:partyid',
  name: 'pingjunjiaResult7',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia7/result'], resolve)
  }
}, {
  path: '/pingjunjia8/index/:partyid',
  name: 'pingjunjiaIndex8',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia8/index'], resolve)
  }
}, {
  path: '/pingjunjia8/result/:partyid',
  name: 'pingjunjiaResult8',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishipingjunjia8/result'], resolve)
  }
}, {
  path: '/pingjunjianew/index/:partyid',
  name: 'pingjunjianewIndex',
  meta: {
    title: '谁是平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/pingjunjia/index'], resolve)
  }
}, {
  path: '/pingjunjianew/result/:partyid',
  name: 'pingjunjianewResult',
  meta: {
    title: '谁是平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/pingjunjia/result'], resolve)
  }
}, {
  path: '/yougongbang',
  name: 'yougongbang',
  meta: {
    title: '邮工帮',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/yougongbang'], resolve)
  }
}, {
  path: '/yougongle',
  name: 'yougongle',
  meta: {
    title: '邮工乐',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/yougongle'], resolve)
  }
}, {
  path: '/yougongXue',
  name: 'yougongXue',
  meta: {
    title: '邮工学',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/yougongxue'], resolve)
  }
}, {
  path: '/yougonghui',
  name: 'yougonghui',
  meta: {
    title: '邮工惠',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/yougonghui'], resolve)
  }
}, {
  path: '/youwenhua/:selected/:category',
  name: 'youwenhua',
  meta: {
    title: '邮文化',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/youwenhua'], resolve)
  }
}, {
  path: '/booklist/:code/:name',
  name: 'booklist',
  meta: {
    title: '电子书',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/booklist'], resolve)
  }
}, {
  path: '/bookdetail/:code',
  name: 'bookdetail',
  meta: {
    title: '电子书',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/bookdetail'], resolve)
  }
}, {
  path: '/funvjie/:selected/:category',
  name: 'funvjie',
  meta: {
    title: '三八国际妇女节专栏',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/funvjie'], resolve)
  }
}, {
  path: '/chuyi/:category',
  name: 'chuyi',
  meta: {
    title: '职工之家厨艺大赛',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/chuyi'], resolve)
  }
}, {
  path: '/pufaweijiangtang',
  name: 'pufaweijiangtang',
  meta: {
    title: '普法微讲堂',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/pufaweijiangtang'], resolve)
  }
}, {
  path: '/xinyundachoujiang/lottery/:partyid',
  name: 'xinyundachoujiang',
  meta: {
    title: '幸运大抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/xinyundachoujiang/lottery'], resolve)
  }
},
// 幸运大抽奖活动模版
{
  path: '/xinyundachoujiang/temp/:partyid',
  name: 'xinyundachoujiangTemp',
  meta: {
    title: '幸运大抽奖',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/xinyundachoujiang/template'], resolve)
  }
},
{
  path: '/chunjiedati/index/:partyid',
  name: 'chuanjiedatiIndex',
  meta: {
    title: '春节答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-chunjiedati/index'], resolve)
  }
}, {
  path: '/chunjiedati/rule/:partyid',
  name: 'chuanjiedatiRule',
  meta: {
    title: '春节答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-chunjiedati/rule'], resolve)
  }
}, {
  path: '/chunjiedati/answer/:partyid/:partyuserid',
  name: 'chuanjiedatiAnswer',
  meta: {
    title: '春节答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-chunjiedati/answer'], resolve)
  }
}, {
  path: '/chunjiedati/lottery/:partyid/:partyuserid',
  name: 'chuanjiedatiLottery',
  meta: {
    title: '春节答题',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-chunjiedati/lottery'], resolve)
  }
}, {
  path: '/niandupingjunjia/index/:partyid',
  name: 'niandupingjunjiaIndex',
  meta: {
    title: '年货平均价',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/niandupingjunjia/index'], resolve)
  }
}, {
  path: '/niandupingjunjia/result/:partyid',
  name: 'niandupingjunjiaResult',
  meta: {
    title: '年度平均价开奖公告',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/niandupingjunjia/result'], resolve)
  }
}, {
  path: '/caidengmi/index/:partyid',
  name: 'caidengmi',
  meta: {
    title: '猜灯谜',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-caidengmi/index'], resolve)
  }
}, {
  path: '/caidengmi/address/:partyid',
  name: 'caidengmiAddress',
  meta: {
    title: '猜灯谜',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-caidengmi/address'], resolve)
  }
}, {
  path: '/caidengmi/rule/:partyid',
  name: 'caidengmiRule',
  meta: {
    title: '猜灯谜',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-caidengmi/rule'], resolve)
  }
}, {
  path: '/caidengmi/answer/:partyid/:partyuserid',
  name: 'caidengmiAnswer',
  meta: {
    title: '猜灯谜',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-caidengmi/answer'], resolve)
  }
}, {
  path: '/caidengmi/lottery/:partyid',
  name: 'caidengmiLottery',
  meta: {
    title: '猜灯谜',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-caidengmi/lottery'], resolve)
  }
}, {
  path: '/fangyi/index/:partyid',
  name: 'fangyiIndex',
  meta: {
    title: '防疫知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-fangyi/index'], resolve)
  }
}, {
  path: '/fangyi/rule/:partyid',
  name: 'fangyiRule',
  meta: {
    title: '防疫知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-fangyi/rule'], resolve)
  }
}, {
  path: '/fangyi/answer/:partyid/:partyuserid',
  name: 'fangyiAnswer',
  meta: {
    title: '防疫知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-fangyi/answer'], resolve)
  }
}, {
  path: '/fangyi/lottery/:partyid/:partyuserid',
  name: 'fangyiLottery',
  meta: {
    title: '防疫知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-fangyi/lottery'], resolve)
  }
}, {
  path: '/nvzhigongquanyi/index/:partyid',
  name: 'nvzhigongquanyiIndex',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi/index'], resolve)
  }
}, {
  path: '/nvzhigongquanyi/answer/:partyid/:partyuserid',
  name: 'nvzhigongquanyiAnswer',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi/answer'], resolve)
  }
}, {
  path: '/nvzhigongquanyi2/index/:partyid',
  name: 'nvzhigongquanyiIndex2',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi2/index'], resolve)
  }
}, {
  path: '/nvzhigongquanyi2/rule/:partyid',
  name: 'nvzhigongquanyiRule2',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi2/rule'], resolve)
  }
}, {
  path: '/nvzhigongquanyi2/answer/:partyid/:partyuserid',
  name: 'nvzhigongquanyiAnswer2',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi2/answer'], resolve)
  }
}, {
  path: '/nvzhigongquanyi2/lottery/:partyid/:partyuserid',
  name: 'nvzhigongquanyiLottery2',
  meta: {
    title: '女职工权益知识竞答',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-nvzhigongquanyi2/lottery'], resolve)
  }
}, {
  path: '/pufaxuanchuan/index/:partyid',
  name: 'pufaxuanchuanIndex',
  meta: {
    title: '安全教育普法宣传',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-pufaxuanchuan/index'], resolve)
  }
}, {
  path: '/pufaxuanchuan/rule/:partyid',
  name: 'pufaxuanchuanRule',
  meta: {
    title: '安全教育普法宣传',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-pufaxuanchuan/rule'], resolve)
  }
}, {
  path: '/pufaxuanchuan/answer/:partyid/:partyuserid',
  name: 'pufaxuanchuanAnswer',
  meta: {
    title: '安全教育普法宣传',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-pufaxuanchuan/answer'], resolve)
  }
}, {
  path: '/pufaxuanchuan/lottery/:partyid/:partyuserid',
  name: 'pufaxuanchuanLottery',
  meta: {
    title: '安全教育普法宣传',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-pufaxuanchuan/lottery'], resolve)
  }
}, {
  path: '/dakaowen520/index/:partyid',
  name: 'dakaowenIndex',
  meta: {
    title: '520送命大拷问',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-dakaowen520/index'], resolve)
  }
}, {
  path: '/dakaowen520/rule/:partyid',
  name: 'dakaowenRule',
  meta: {
    title: '520送命大拷问',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-dakaowen520/rule'], resolve)
  }
}, {
  path: '/dakaowen520/answer/:partyid/:partyuserid',
  name: 'dakaowenAnswer',
  meta: {
    title: '520送命大拷问',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-dakaowen520/answer'], resolve)
  }
}, {
  path: '/dakaowen520/lottery/:partyid/:partyuserid',
  name: 'dakaowenLottery',
  meta: {
    title: '送命大拷问',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-dakaowen520/lottery'], resolve)
  }
}, {
  path: '/woxinxiangdang/index/:partyid',
  name: 'woxinxiangdangIndex',
  meta: {
    title: '我心向党知识竞赛',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-woxinxiangdang/index'], resolve)
  }
}, {
  path: '/woxinxiangdang/rule/:partyid',
  name: 'woxinxiangdangRule',
  meta: {
    title: '我心向党知识竞赛',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-woxinxiangdang/rule'], resolve)
  }
}, {
  path: '/woxinxiangdang/answer/:partyid/:partyuserid',
  name: 'woxinxiangdangAnswer',
  meta: {
    title: '我心向党知识竞赛',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-woxinxiangdang/answer'], resolve)
  }
}, {
  path: '/woxinxiangdang/lottery/:partyid/:partyuserid',
  name: 'woxinxiangdangLottery',
  meta: {
    title: '我心向党知识竞赛',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-woxinxiangdang/lottery'], resolve)
  }
}, {
  path: '/mydaiban',
  name: 'mydaiban',
  meta: {
    title: '我的待办',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/mydaiban'], resolve)
  }
}, {
  path: '/shaoshupai',
  name: 'shaoshupai',
  meta: {
    title: '谁是少数派',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishishaoshupai/index'], resolve)
  }
}, {
  path: '/shaoshupai/index/:id',
  name: 'shaoshupai2',
  meta: {
    title: '谁是少数派',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishishaoshupai/index'], resolve)
  }
}, {
  path: '/shaoshupai2',
  name: 'shaoshupaiindex2',
  meta: {
    title: '谁是少数派',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishishaoshupai2/index'], resolve)
  }
}, {
  path: '/shaoshupai/result',
  name: 'shaoshupaiResult',
  meta: {
    title: '竞猜记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishishaoshupai/result'], resolve)
  }
}, {
  path: '/shaoshupai2/result',
  name: 'shaoshupai2Result',
  meta: {
    title: '竞猜记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/shuishishaoshupai2/result'], resolve)
  }
}, {
  path: '/jianjunzhishi/index/:partyid',
  name: 'jianjunzhishiIndex',
  meta: {
    title: '建军知识知多少',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jianjunzhishi/index'], resolve)
  }
}, {
  path: '/jianjunzhishi/rule/:partyid',
  name: 'jianjunzhishiRule',
  meta: {
    title: '建军知识知多少',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jianjunzhishi/rule'], resolve)
  }
}, {
  path: '/jianjunzhishi/answer/:partyid/:partyuserid',
  name: 'jianjunzhishiAnswer',
  meta: {
    title: '建军知识知多少',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jianjunzhishi/answer'], resolve)
  }
}, {
  path: '/jianjunzhishi/lottery/:partyid/:partyuserid',
  name: 'jianjunzhishiLottery',
  meta: {
    title: '建军知识知多少',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jianjunzhishi/lottery'], resolve)
  }
}, {
  path: '/jiaoyuweiben/index/:partyid',
  name: 'jiaoyuweibenIndex',
  meta: {
    title: '千秋基业，教育为本',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jiaoyuweiben/index'], resolve)
  }
}, {
  path: '/jiaoyuweiben/rule/:partyid',
  name: 'jiaoyuweibenRule',
  meta: {
    title: '千秋基业，教育为本',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jiaoyuweiben/rule'], resolve)
  }
}, {
  path: '/jiaoyuweiben/answer/:partyid/:partyuserid',
  name: 'jiaoyuweibenAnswer',
  meta: {
    title: '千秋基业，教育为本',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jiaoyuweiben/answer'], resolve)
  }
}, {
  path: '/jiaoyuweiben/lottery/:partyid/:partyuserid',
  name: 'jiaoyuweibenLottery',
  meta: {
    title: '千秋基业，教育为本',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-jiaoyuweiben/lottery'], resolve)
  }
}, {
  path: '/guojiagongji/index/:partyid',
  name: 'guojiagongjiIndex',
  meta: {
    title: '国家公祭日',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-guojiagongji/index'], resolve)
  }
}, {
  path: '/guojiagongji/rule/:partyid',
  name: 'guojiagongjiRule',
  meta: {
    title: '国家公祭日',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-guojiagongji/rule'], resolve)
  }
}, {
  path: '/guojiagongji/answer/:partyid/:partyuserid',
  name: 'guojiagongjiAnswer',
  meta: {
    title: '国家公祭日',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-guojiagongji/answer'], resolve)
  }
}, {
  path: '/guojiagongji/lottery/:partyid/:partyuserid',
  name: 'guojiagongjiLottery',
  meta: {
    title: '国家公祭日',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-guojiagongji/lottery'], resolve)
  }
}, {
  path: '/qingnuanchongyang/index/:partyid',
  name: 'qingnuanchongyangIndex',
  meta: {
    title: '情暖重阳，不忘传统',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingnuanchongyang/index'], resolve)
  }
}, {
  path: '/qingnuanchongyang/rule/:partyid',
  name: 'qingnuanchongyangRule',
  meta: {
    title: '情暖重阳，不忘传统',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingnuanchongyang/rule'], resolve)
  }
}, {
  path: '/qingnuanchongyang/answer/:partyid/:partyuserid',
  name: 'qingnuanchongyangAnswer',
  meta: {
    title: '情暖重阳，不忘传统',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingnuanchongyang/answer'], resolve)
  }
}, {
  path: '/qingnuanchongyang/lottery/:partyid/:partyuserid',
  name: 'qingnuanchongyangLottery',
  meta: {
    title: '情暖重阳，不忘传统',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingnuanchongyang/lottery'], resolve)
  }
}, {
  path: '/wuzhonquanhui/index/:partyid',
  name: 'wuzhonquanhuiIndex',
  meta: {
    title: '十九届五中全会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-wuzhonquanhui/index'], resolve)
  }
}, {
  path: '/wuzhonquanhui/rule/:partyid',
  name: 'wuzhonquanhuiRule',
  meta: {
    title: '十九届五中全会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-wuzhonquanhui/rule'], resolve)
  }
}, {
  path: '/wuzhonquanhui/answer/:partyid/:partyuserid',
  name: 'wuzhonquanhuiAnswer',
  meta: {
    title: '十九届五中全会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-wuzhonquanhui/answer'], resolve)
  }
}, {
  path: '/wuzhonquanhui/lottery/:partyid/:partyuserid',
  name: 'wuzhonquanhuiLottery',
  meta: {
    title: '十九届五中全会',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-wuzhonquanhui/lottery'], resolve)
  }
},
{
  path: '/qingxinvzhigong/index/:partyid',
  name: 'qingxinvzhigongIndex',
  meta: {
    title: '激扬巾帼志 奋进新征程',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingxinvzhigong/index'], resolve)
  }
}, {
  path: '/qingxinvzhigong/rule/:partyid',
  name: 'qingxinvzhigongRule',
  meta: {
    title: '激扬巾帼志 奋进新征程',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingxinvzhigong/rule'], resolve)
  }
}, {
  path: '/qingxinvzhigong/answer/:partyid/:partyuserid',
  name: 'qingxinvzhigongAnswer',
  meta: {
    title: '激扬巾帼志 奋进新征程',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingxinvzhigong/answer'], resolve)
  }
}, {
  path: '/qingxinvzhigong/lottery/:partyid',
  name: 'qingxinvzhigongLottery',
  meta: {
    title: '激扬巾帼志 奋进新征程',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-qingxinvzhigong/lottery'], resolve)
  }
},
{
  path: '/zhumengxinzhencheng/index/:partyid',
  name: 'zhumengxinzhenchengIndex',
  meta: {
    title: '逐梦新征程·奋进向未来',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zhumengxinzhencheng/index'], resolve)
  }
}, {
  path: '/zhumengxinzhencheng/rule/:partyid',
  name: 'zhumengxinzhenchengRule',
  meta: {
    title: '逐梦新征程·奋进向未来',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zhumengxinzhencheng/rule'], resolve)
  }
}, {
  path: '/zhumengxinzhencheng/answer/:partyid/:partyuserid',
  name: 'zhumengxinzhenchengAnswer',
  meta: {
    title: '逐梦新征程·奋进向未来',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zhumengxinzhencheng/answer'], resolve)
  }
}, {
  path: '/zhumengxinzhencheng/lottery/:partyid',
  name: 'zhumengxinzhenchengLottery',
  meta: {
    title: '逐梦新征程·奋进向未来',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/answerlottery-zhumengxinzhencheng/lottery'], resolve)
  }
},
{
  path: '/choujiang/:partyid',
  name: 'choujiang',
  meta: {
    title: '抽奖活动',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t1/index'], resolve)
  }
}, {
  path: '/choujiang/result/:lotid',
  name: 'choujiangResult',
  meta: {
    title: '中奖记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t1/result'], resolve)
  }
}, {
  path: '/choujiang2/:partyid',
  name: 'choujiang2',
  meta: {
    title: '抽奖活动',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t2/index'], resolve)
  }
}, {
  path: '/choujiang2/result/:lotid',
  name: 'choujiang2Result',
  meta: {
    title: '中奖记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t2/result'], resolve)
  }
},
// 万圣节抽奖活动
{
  path: '/choujiang3/:partyid',
  name: 'choujiang3',
  meta: {
    title: '万圣狂欢',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t3/index'], resolve)
  }
}, {
  path: '/choujiang3/result/:lotid',
  name: 'choujiang3Result',
  meta: {
    title: '中奖记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t3/result'], resolve)
  }
}, {
  path: '/choujiang4/:partyid',
  name: 'choujiang4',
  meta: {
    title: '情暖冬日',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t4/index'], resolve)
  }
}, {
  path: '/choujiang4/result/:lotid',
  name: 'choujiang4Result',
  meta: {
    title: '中奖记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/t4/result'], resolve)
  }
}, {
  path: '/choujiang61/:partyid',
  name: 'choujiang61',
  meta: {
    title: '谁还不是个宝宝',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/61/index'], resolve)
  }
}, {
  path: '/choujiang61/result/:lotid',
  name: 'choujiangResult61',
  meta: {
    title: '中奖记录',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/choujiang/61/result'], resolve)
  }
}, {
  path: '/zgsw',
  name: 'zgsw',
  meta: {
    title: '职工书屋',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zgsw'], resolve)
  }
},
// 父亲节活动
{
  path: '/fathersday/:artid',
  name: 'fathersdayMain',
  component: resolve => {
    require(['@/views/fathersday/main'], resolve)
  },
  // redirect: {
  //   name: 'fathersdayIndex'
  // },
  meta: {
    title: '今天就要炫父',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/fathersday/index/:artid',
    name: 'fathersdayIndex',
    component: resolve => {
      require(['@/views/fathersday/index'], resolve)
    },
    meta: {
      title: '今天就要炫父',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/fathersday/list/:artid',
    name: 'fathersdayList',
    component: resolve => {
      require(['@/views/fathersday/list'], resolve)
    },
    meta: {
      title: '今天就要炫父',
      NeedLogin: false,
      keepAlive: true
    }
  },
  {
    path: '/fathersday/voterank/:artid',
    name: 'fathersdayRank',
    component: resolve => {
      require(['@/views/fathersday/voterank'], resolve)
    },
    meta: {
      title: '今天就要炫父',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/fathersday/detail/:artid/:voteid',
    name: 'fathersdayDetail',
    component: resolve => {
      require(['@/views/fathersday/detail'], resolve)
    },
    meta: {
      title: '今天就要炫父',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/fathersday/rule/:artid',
    name: 'fathersdayRule',
    component: resolve => {
      require(['@/views/fathersday/rule'], resolve)
    },
    meta: {
      title: '今天就要炫父',
      NeedLogin: false,
      keepAlive: false
    }
  }
  ]
},
{
  path: '/niulangzhinv/:artid',
  name: 'niulangzhinvMain',
  component: resolve => {
    require(['@/views/niulangzhinv/main'], resolve)
  },
  // redirect: {
  //   name: 'fathersdayIndex'
  // },
  meta: {
    title: '黄昏后，柳梢头牛郎织女牵手手',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/niulangzhinv/index/:artid',
    name: 'niulangzhinvIndex',
    component: resolve => {
      require(['@/views/niulangzhinv/index'], resolve)
    },
    meta: {
      title: '黄昏后，柳梢头牛郎织女牵手手',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/niulangzhinv/list/:artid',
    name: 'niulangzhinvList',
    component: resolve => {
      require(['@/views/niulangzhinv/list'], resolve)
    },
    meta: {
      title: '黄昏后，柳梢头牛郎织女牵手手',
      NeedLogin: false,
      keepAlive: true
    }
  },
  {
    path: '/niulangzhinv/voterank/:artid',
    name: 'niulangzhinvRank',
    component: resolve => {
      require(['@/views/niulangzhinv/voterank'], resolve)
    },
    meta: {
      title: '黄昏后，柳梢头牛郎织女牵手手',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/niulangzhinv/detail/:artid/:voteid',
    name: 'niulangzhinvDetail',
    component: resolve => {
      require(['@/views/niulangzhinv/detail'], resolve)
    },
    meta: {
      title: '黄昏后，柳梢头牛郎织女牵手手',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/niulangzhinv/rule/:artid',
    name: 'niulangzhinvRule',
    component: resolve => {
      require(['@/views/niulangzhinv/rule'], resolve)
    },
    meta: {
      title: '黄昏后，柳梢头牛郎织女牵手手',
      NeedLogin: false,
      keepAlive: false
    }
  }
  ]
},
// 放礼花，迎国庆
{
  path: '/yingguoqing/:artid',
  name: 'yingguoqingMain',
  component: resolve => {
    require(['@/views/yingguoqing/main'], resolve)
  },
  // redirect: {
  //   name: 'fathersdayIndex'
  // },
  meta: {
    title: '放礼花，迎国庆',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/yingguoqing/index/:artid',
    name: 'yingguoqingIndex',
    component: resolve => {
      require(['@/views/yingguoqing/index'], resolve)
    },
    meta: {
      title: '放礼花，迎国庆',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/yingguoqing/list/:artid',
    name: 'yingguoqingList',
    component: resolve => {
      require(['@/views/yingguoqing/list'], resolve)
    },
    meta: {
      title: '放礼花，迎国庆',
      NeedLogin: false,
      keepAlive: true
    }
  },
  {
    path: '/yingguoqing/voterank/:artid',
    name: 'yingguoqingRank',
    component: resolve => {
      require(['@/views/yingguoqing/voterank'], resolve)
    },
    meta: {
      title: '放礼花，迎国庆',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/yingguoqing/detail/:artid/:voteid',
    name: 'yingguoqingDetail',
    component: resolve => {
      require(['@/views/yingguoqing/detail'], resolve)
    },
    meta: {
      title: '放礼花，迎国庆',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/yingguoqing/rule/:artid',
    name: 'yingguoqingRule',
    component: resolve => {
      require(['@/views/yingguoqing/rule'], resolve)
    },
    meta: {
      title: '放礼花，迎国庆',
      NeedLogin: false,
      keepAlive: false
    }
  }
  ]
},
// 厨艺大赛投票
{
  path: '/chuyidasai/:artid',
  name: 'chuyidasaiMain',
  component: resolve => {
    require(['@/views/chuyidasai/main'], resolve)
  },
  // redirect: {
  //   name: 'fathersdayIndex'
  // },
  meta: {
    title: '厨艺大赛投票',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/chuyidasai/index/:artid',
    name: 'chuyidasaiIndex',
    component: resolve => {
      require(['@/views/chuyidasai/index'], resolve)
    },
    meta: {
      title: '厨艺大赛投票',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/chuyidasai/list/:artid',
    name: 'chuyidasaiList',
    component: resolve => {
      require(['@/views/chuyidasai/list'], resolve)
    },
    meta: {
      title: '厨艺大赛投票',
      NeedLogin: false,
      keepAlive: true
    }
  },
  {
    path: '/chuyidasai/voterank/:artid',
    name: 'chuyidasaiRank',
    component: resolve => {
      require(['@/views/chuyidasai/voterank'], resolve)
    },
    meta: {
      title: '厨艺大赛投票',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/chuyidasai/detail/:artid/:voteid',
    name: 'chuyidasaiDetail',
    component: resolve => {
      require(['@/views/chuyidasai/detail'], resolve)
    },
    meta: {
      title: '厨艺大赛投票',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/chuyidasai/rule/:artid',
    name: 'chuyidasaiRule',
    component: resolve => {
      require(['@/views/chuyidasai/rule'], resolve)
    },
    meta: {
      title: '厨艺大赛投票',
      NeedLogin: false,
      keepAlive: false
    }
  }
  ]
},
// 双旦礼遇季
{
  path: '/shuangdanliyu/:artid',
  name: 'shuangdanliyuMain',
  component: resolve => {
    require(['@/views/shuangdanliyu/main'], resolve)
  },
  // redirect: {
  //   name: 'fathersdayIndex'
  // },
  meta: {
    title: '双旦礼遇季',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/shuangdanliyu/index/:artid',
    name: 'shuangdanliyuIndex',
    component: resolve => {
      require(['@/views/shuangdanliyu/index'], resolve)
    },
    meta: {
      title: '双旦礼遇季',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/shuangdanliyu/list/:artid',
    name: 'shuangdanliyuList',
    component: resolve => {
      require(['@/views/shuangdanliyu/list'], resolve)
    },
    meta: {
      title: '双旦礼遇季',
      NeedLogin: false,
      keepAlive: true
    }
  },
  {
    path: '/shuangdanliyu/voterank/:artid',
    name: 'shuangdanliyuRank',
    component: resolve => {
      require(['@/views/shuangdanliyu/voterank'], resolve)
    },
    meta: {
      title: '双旦礼遇季',
      NeedLogin: false,
      keepAlive: false
    }
  },
  {
    path: '/shuangdanliyu/detail/:artid/:voteid',
    name: 'shuangdanliyuDetail',
    component: resolve => {
      require(['@/views/shuangdanliyu/detail'], resolve)
    },
    meta: {
      title: '双旦礼遇季',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/shuangdanliyu/rule/:artid',
    name: 'shuangdanliyuRule',
    component: resolve => {
      require(['@/views/shuangdanliyu/rule'], resolve)
    },
    meta: {
      title: '双旦礼遇季',
      NeedLogin: false,
      keepAlive: false
    }
  }
  ]
},
// 骰子活动
{
  path: '/diceactivity/:artid',
  name: 'diceactivity',
  component: resolve => {
    require(['@/views/dice/main'], resolve)
  },
  redirect: {
    name: 'diceactivityIndex'
  },
  meta: {
    title: '骰子活动',
    NeedLogin: false,
    keepAlive: false
  },
  children: [{
    path: '/diceactivity/index/:artid',
    name: 'diceactivityIndex',
    component: resolve => {
      require(['@/views/dice/index'], resolve)
    },
    meta: {
      title: '骰子活动',
      NeedLogin: false,
      keepAlive: false
    }
  }, {
    path: '/diceactivity/rule/:artid',
    name: 'diceactivityRule',
    component: resolve => {
      require(['@/views/dice/rule'], resolve)
    },
    meta: {
      title: '骰子活动规则',
      NeedLogin: false,
      keepAlive: false
    }
  }]
}
]
export default youzheng
